// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Why a project page could not show its project: the project is gone or not this account's (the server
// answered 404 or 403), or it did not load this time (any other failure, a network error included).
export type ProjectLoadFailure = 'notFound' | 'loadFailed';

// What a project read's result means for the page; null when the project loaded.
export const projectLoadFailure = (result: unknown): ProjectLoadFailure | null => {
  const { success, status } = (result ?? {}) as Partial<IApiResponse<unknown>>;
  if (success) return null;
  return status === 404 || status === 403 ? 'notFound' : 'loadFailed';
};
